
module.exports = {
	reachGoal: function yaCounterReachGoal (...args) {
		try {
			// eslint-disable-next-line no-undef
			yaCounter396811.reachGoal(...args);
		} catch (e) {
			if (e instanceof ReferenceError) { // yaCounter396811 is not defined
				console.warn(e);
			} else {
				throw e;
			}
		}
	},
};

